import { Comment } from "../../../models/comment.model.ts";
import { CommentSerializer } from "../../../models/serializers/CommentSerializer.ts";
import { httpRequest } from "../../http";

export class CommandDeleteComment {
    async run(todoId:number,commentId:number) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/todos/${todoId}/comments/${commentId}/`;
        try {
            const response = await httpRequest<any>(url, { method: "DELETE" });
            return this.deserialize(response.comments);
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : Comment []{
        const serializer = new CommentSerializer();
        return serializer.deserializeList(data);
    }
}

